import styles from "./page-placeholder.module.css";

type TPagePlaceholderProps = {
  title: string;
};

export function PagePlaceholder({ title }: TPagePlaceholderProps): JSX.Element {
  return (
    <div className={styles.page}>
      <section className={styles.card} aria-label={title.toLowerCase()}>
        <div className={styles.subtitle}>{title} — coming soon</div>

        <div className={styles.placeholder}>Placeholder content</div>
      </section>
    </div>
  );
}
